export const Shadows = {
  light: {
    xxs: '0 2px 4px -2px rgba(35, 35, 35, 0.2)',
    xs: '0 10px 20px 0 rgba(35, 35, 35, 0.08)',
    sm: '0 9px 14px 0 rgba(35, 35, 35, 0.14)',
    base: '0 12px 16px 0 rgba(35, 35, 35, 0.2)',
    lg: '0 20px 30px 0 rgba(35, 35, 35, 0.2)',
    xl: '0 30px 40px 0 rgba(35, 35, 35, 0.26)',
  },
  dark: {
    xxs: '0 2px 4px -2px rgba(17, 17, 17, 0.5)',
    xs: '0 10px 20px 0 rgba(17, 17, 17, 0.5)',
    sm: '0 9px 14px 0 rgba(17, 17, 17, 0.5)',
    base: '0 12px 16px 0 rgba(17, 17, 17, 0.5)',
    lg: '0 20px 30px 0 rgba(17, 17, 17, 0.6)',
    xl: '0 30px 40px 0 rgba(17, 17, 17, 0.7)',
  },
};
